/**
 * Article enhancements — Design Notes
 * - Builds a Table of Contents from rendered h2/h3 in the article body.
 * - Smooth-scrolls to anchors and highlights the active heading on scroll.
 * - Handles the mobile collapsible TOC toggle.
 * - Copy-link share button.
 *
 * No dependencies, no render-blocking. Loaded with defer.
 */
(function () {
  'use strict';

  function slugify(text, used) {
    var base = (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i++;
    }
    used[slug] = true;
    return slug;
  }

  function buildTOC() {
    var toc = document.querySelector('[data-article-toc]');
    if (!toc) return;

    var content = document.querySelector('[data-article-content]');
    var list = toc.querySelector('[data-toc-list]');
    if (!content || !list) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length < 2) {
      // Not enough structure to warrant a TOC — remove it entirely.
      toc.remove();
      var layout = document.querySelector('[data-article-layout]');
      if (layout) layout.classList.add('article-layout--no-toc');
      return;
    }

    var used = {};
    var links = [];

    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent, used);
      } else {
        used[heading.id] = true;
      }

      var li = document.createElement('li');
      li.className = 'article-toc__item article-toc__item--' + heading.tagName.toLowerCase();

      var a = document.createElement('a');
      a.className = 'article-toc__link';
      a.href = '#' + heading.id;
      a.textContent = heading.textContent;
      a.dataset.tocTarget = heading.id;

      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });

    // Active-state highlighting via IntersectionObserver.
    if ('IntersectionObserver' in window) {
      var linkById = {};
      links.forEach(function (a) { linkById[a.dataset.tocTarget] = a; });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (a) { a.classList.remove('is-active'); });
            var active = linkById[entry.target.id];
            if (active) active.classList.add('is-active');
          }
        });
      }, { rootMargin: '0px 0px -75% 0px', threshold: 0 });

      headings.forEach(function (h) { observer.observe(h); });
    }

    // Mobile collapsible toggle.
    var toggle = toc.querySelector('[data-toc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toc.classList.toggle('is-open', !expanded);
      });

      // Collapse the bar once a destination is chosen.
      list.addEventListener('click', function (e) {
        if (e.target.closest('a')) {
          toggle.setAttribute('aria-expanded', 'false');
          toc.classList.remove('is-open');
        }
      });
    }
  }

  function initCopyLink() {
    var buttons = document.querySelectorAll('[data-copy-link]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-link') || window.location.href;
        var done = function () {
          var label = btn.querySelector('[data-copy-label]');
          var original = label ? label.textContent : null;
          btn.classList.add('is-copied');
          if (label) label.textContent = btn.getAttribute('data-copied-label') || 'Copied';
          window.setTimeout(function () {
            btn.classList.remove('is-copied');
            if (label && original !== null) label.textContent = original;
          }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var temp = document.createElement('input');
          temp.value = url;
          document.body.appendChild(temp);
          temp.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(temp);
          done();
        }
      });
    });
  }

  function init() {
    buildTOC();
    initCopyLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
